
import { NgProgress } from 'ngx-progressbar';
import { ActivatedRoute, Router, NavigationEnd  } from '@angular/router';
import {
    Component,
    OnInit,
    ViewChild,
    ViewContainerRef,
    OnDestroy,
    Inject,
    ElementRef,
    Renderer2,
    AfterViewInit
} from '@angular/core';
import { NgModel } from '@angular/forms';
import { CommonService } from '../../../services';
import { Windows11AssessmentService } from '../../../services/windows-11-assessment.service';
import { NgProgressService } from '../../../services/ngProgress.service';
import { Subscription } from 'rxjs';
import { FinalReportExtractModel,  HardwareDeviceReportModel,  HardwareReadinessModel, WindowsFeatureModel, WorkFromAnywhereModel } from '../../../models/Windows11Readiness.model';

@Component({
    selector: 'app-windows-11-report-extract',
    templateUrl: './windows-11-report-extract.component.html',
    styleUrls: ['./windows-11-report-extract.component.css'],
})
export class Windows11ReportExtractComponent implements OnInit, OnDestroy {
    @ViewChild("ParentWrapper", { static: false }) parentWrapper: ElementRef;

    created = false;
    loadContent = false;
    
    @ViewChild('entry', { read: ViewContainerRef }) entry: ViewContainerRef;
    @ViewChild('brandSelect') private brandSelect: NgModel;

    windowsReportsActiveRouter: Subscription;
    windowsReportsActiveRouterParent: Subscription;
    windowsReportsRouterParaChange: Subscription;

    isLoading = true;

    readinessCount: Record<string, number> = {};
    upgradeCount: Record<string, number> = {};
    returnCodeCount: Record<string, number> = {};
    finalReport: FinalReportExtractModel[] = [];
    reportGroups: { [key: string]: FinalReportExtractModel[] } = {};
    modelType: 'windowsFeature' | 'workFromAnywhere' | 'hardwareReadiness' | null = null;
    expandedPanels = [true, true];

    constructor(
        private activeRouter: ActivatedRoute,
        public ngProgress: NgProgressService,
        private router: Router,
        private commonService: CommonService,
        private windows11AssessmentService: Windows11AssessmentService,
        private renderer: Renderer2, 
        private el: ElementRef,
        @Inject(ViewContainerRef) private viewContainerRef
    ) {
        this.windows11AssessmentService.win11ModelType$.subscribe(type => {
            this.modelType = type;
          });
    }

    ngOnInit() {
        this.windowsReportsRouterParaChange = this.activeRouter.paramMap.subscribe(param => {
            $('.child-loader').animate({ scrollLeft: $('#win-11-report-detail').width() + $('#windows-11-report-extract').width()}, 300);
            this.loadContent = false;
            this.windowsReportsActiveRouter = this.activeRouter.url.subscribe(value => {
            },
            (error: any) => {
                console.error(error);
                this.ngProgress.done();
            });
            this.loadData()
        });
    }

    loadData(){
        if(this.modelType === 'windowsFeature') {
        this.windows11AssessmentService.windowsFeature$.subscribe(data => {
            if (data) {
                this.fromWindowsFeature(data);
                console.log("Windows Feature Data", data);
            }
          });
        }
        else if(this.modelType === 'workFromAnywhere') {
          this.windows11AssessmentService.workAnywhere$.subscribe(data => {
            if (data) {
              this.fromWorkAnywhere(data);
              console.log("Work Anywhere Data", data);
            }
          });
        }
        else if(this.modelType === 'hardwareReadiness') {
          this.windows11AssessmentService.hardwareReadiness$.subscribe(data => {
            if (data)  {
                this.fromHardwareReadiness(data);
                console.log("Hardware Readiness Data", data);
            }
          });
        }
    }

    ngAfterViewInit() {
        const elements = this.el.nativeElement.querySelectorAll('.report-button-container');
        elements.forEach((element: HTMLElement) => {
            this.renderer.setStyle(element, 'display', 'none');
        });
    }

    fromWorkAnywhere(data: WorkFromAnywhereModel[]): void {
        const failureLabels: { [key in keyof WorkFromAnywhereModel]?: string } = {
            RamCheckFailed: 'RAM Check Failed',
            StorageCheckFailed: 'Storage Check Failed',
            ProcessorCoreCountCheckFailed: 'Processor Core Count Check Failed',
            ProcessorSpeedCheckFailed: 'Processor Speed Check Failed',
            TPMCheckFailed: 'TPM Check Failed',
            SecureBootCheckFailed: 'Secure Boot Check Failed',
            ProcessorFamilyCheckFailed: 'Processor Family Check Failed',
            Processor64BitCheckFailed: 'Processor 64-Bit Check Failed',
            OSCheckFailed: 'OS Check Failed'
          };
        
          this.finalReport = data.map(row => {
            const reasons: string[] = [];
            
             let upgradeStatus = -1; 
            //0-Upgraded 1-Unknown 2-Not capable  3-Capable
            if (this.windows11AssessmentService.isOSVersionGreater(row.OSVersion)) {
                reasons.push('Upgraded');
                upgradeStatus = 0; // Upgraded
              } else if (Number(row.UpgradeEligibility) === 1) {
                reasons.push('Unknown');
                upgradeStatus = 1; // Unknown
              } else if (Number(row.UpgradeEligibility) === 3) {
                reasons.push('Capable of Upgrading');
                upgradeStatus = 3; 
            } 
            else if (Number(row.UpgradeEligibility) === 2) {
                upgradeStatus = 2; 
            } 
            // if (Number(row.UpgradeEligibility) === 0) {
            //   reasons.push('Upgraded');
            // } else if (Number(row.UpgradeEligibility) === 1) {
            //   reasons.push('Unknown');
            // } else if (Number(row.UpgradeEligibility) === 3) {
            //   reasons.push('Capable of Upgrading');
            // } 
        
            const failures = Object.entries(failureLabels)
              .filter(([key]) => String(row[key as keyof WorkFromAnywhereModel]).toLowerCase() === 'true')
              .map(([_, label]) => label ?? '')
              .filter(reason => reason !== '');
        
            return {
              DeviceName: row.DeviceName,
              OSVersion: row.OSVersion,
              UpgradeEligibility: upgradeStatus.toString(), 
              Reason: [reasons, failures].join(' ')
            };
          });
        
        console.log("Final Report", this.finalReport);
        this.reportGroups = this.groupByEligibility(this.finalReport);
      }
      
      fromWindowsFeature(data: WindowsFeatureModel[]): void {
        const featureLabels: { [key in keyof WindowsFeatureModel]?: string } = {
            SystemRequirements: 'System Requirements',
            AppIssuesCount: 'App Issues Count',
            DriverIssuesCount: 'Driver Issues Count',
            AppOtherIssuesCount: 'App Other Issues Count'
          };
        
          this.finalReport = data.map(row => {
            let reasons: string[] = [];
            let failures: string[] = [];
            let upgradeEligibility = -1;
            //0 -	Low risk  1-Medium risk 2-High risk 3-Replace device 4-Upgraded 5-Unknown
            if (Number(row.ReadinessStatus) === 4 || this.windows11AssessmentService.isOSVersionGreater(row.OSVersion)) {
                reasons.push('Upgraded');
                upgradeEligibility = 0; // Upgraded
              } 
              else if (Number(row.ReadinessStatus) === 0|| Number(row.ReadinessStatus) === 1
                                || Number(row.ReadinessStatus) === 2 || Number(row.ReadinessStatus) === 5) {
                upgradeEligibility = 1; // Unknown
                reasons.push('Unknown');
              } 
              else if (Number(row.ReadinessStatus) === 3) {
                    failures = Object.entries(featureLabels)
                .filter(([key]) => row[key as keyof WindowsFeatureModel[]] > 0)
                .map(([_, label]) => label ?? '')
                .filter(reason => reason !== '');
                upgradeEligibility = 2; // Not capable
              }
            return {
                          DeviceName: row.DeviceName,
                          OSVersion: row.OSVersion,
                          UpgradeEligibility: upgradeEligibility.toString(), // Convert to string
                          Reason: Number(row.ReadinessStatus) === 3 ? [reasons, failures].join(' ') : reasons.join(' ')
                        };
          });
        this.reportGroups = this.groupByEligibility(this.finalReport);
      }
      
      fromHardwareReadiness(data: HardwareDeviceReportModel[]): void {
       
        if (data && data.length > 0) {
          // Initialize finalReport
          this.finalReport = [];
          let upgradeEligibility = -10;
          data.forEach(item => {
            try {
              const parsedResult = typeof item.Result === 'string' ? JSON.parse(item.Result) : item.Result;
              // Extract returnCode
              const returnCode = parsedResult?.returnCode;// Default to 3 (unknown) if returnCode is missing
      
              //-2 - Failed To Run -1 - UnDetermined 0 - Capable 1 - Not Capable
              //let reason = '';
              let reason: string[] = [];
              let failure: string[] = [];
                if (returnCode === 0 || this.windows11AssessmentService.isOSVersionGreater(this.windows11AssessmentService.extractNumericOSVersion(item.OSVersion))) {
                    reason.push('Upgraded');
                    upgradeEligibility = 0; // Capable
                }
                else if (returnCode === -1 || returnCode === -2) {
                    reason.push('Unknown');
                    upgradeEligibility = 3; // Unknown
                  }
                else if (returnCode === 1) {
                upgradeEligibility = 2; // Not capable
                // const logging = parsedResult?.logging || '';
                // const loggingEntries = logging.split(';'); // Split logging into key-value pairs
                // loggingEntries.forEach(entry => {
                // const [key, value] = entry.split(':').map(part => part.trim()); // Split key-value and trim spaces
                // console.log("Key", key, "Value", value);
                // if (value && value.includes('FAIL')) {
                //     failure.push(key + ':' + value); // Add the key to failures if the value contains "FAIL"
                // }
                // });

                const logging = parsedResult?.logging || '';
                const loggingEntries = logging.split('PASS;'); // Split logging into key-value pairs by "PASS;"

                loggingEntries.forEach(entry => {
                // Split the entry into key and value
                const [key, value] = entry.split(':').map(part => part.trim());
                console.log("Key", key, "Value", value);

                // Check if the value contains "FAIL"
                if (value && value.includes('FAIL')) {
                    failure.push(`${key}: ${value}`); // Add the key and value to failures
                }
                });
              } 
              this.finalReport.push({
                DeviceName: item.DeviceName,
                OSVersion: item.OSVersion,
                UpgradeEligibility: upgradeEligibility.toString(), // Convert to string
                Reason: Number(returnCode) === 1 ? [reason, failure].join(' ') : reason.join(' ')
              });
            } catch (error) {
              console.error('Error processing item:', item, error);
            }
          });
        } else {
          this.finalReport = [];
        }
          this.reportGroups = this.groupByEligibility(this.finalReport);
      }
      
    groupByEligibility(data: FinalReportExtractModel[]): { [key: string]: FinalReportExtractModel[] } {
        return data.reduce((acc, item) => {
          const key = item.UpgradeEligibility || 'unknown';
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(item);
          return acc;
        }, {} as { [key: string]: FinalReportExtractModel[] });
    }
      
    getKeys(obj: { [key: string]: any }): string[] {
        return Object.keys(obj);
    }
      
    getByEligibilityGroup(eligibility: string): FinalReportExtractModel[] {
        return this.reportGroups[eligibility] || [];
    }
      
    hasEligibilityGroup(eligibility: string): boolean {
        return this.reportGroups[eligibility]?.length > 0;
    }
    ngOnDestroy(): void {
        // this.closesub$.unsubscribe();
    }

    close() {
        this.router.navigateByUrl('/windows-11-readiness/windows-11-report');
        $('.child-loader').animate({ scrollLeft: $('#win-11-report').width() }, 100);
    }

    onLoading(currentLoadingStatus: boolean) {
        this.ngProgress.done();
        console.log("currentLoadingStatus", currentLoadingStatus);
        this.loadContent = !currentLoadingStatus;
        console.log("loadContent", this.loadContent);
    }
    onNavigate(id, url) {
        
        window.open(url, '_blank');
    }
}